import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button
} from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import { Layout } from 'components/atoms';
import { InputBuild, SelectBuild } from 'components/molecules';
import { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { formFilterHistory } from './form';
import { FilterHistoryProps, FormFilterValues } from './interfaces';
import { schema } from './schema';
import { FormHistoryElements } from './types';

const initialState = {
    numeroContrato: "",
    usuario: "",
    dataInicio: "",
    dataFim: "",
    chassi: "",
    intituicaoFinanceira: "",
    uf: ""
}

export const FilterHistory = ({ onSearch, isLoading }: FilterHistoryProps) => {
  const formData = useMemo(() => formFilterHistory, []);
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    watch 
  } = useForm<FormFilterValues>({
    resolver: yupResolver(schema),
    mode: 'onChange',
    defaultValues: initialState
  });

  const handleClear = () => {
    reset({ ...initialState });
    onSearch({});
  };

  const onSubmit = (value: FormFilterValues) => {
    onSearch(value);
  };

  return (
    <Accordion
      allowMultiple
      backgroundColor={'white'}
      marginBottom={4}
      defaultIndex={[]}
    >
      <AccordionItem>
        <h2>
          <AccordionButton backgroundColor={'white'}>
            <Box as="h2" flex="1" textAlign="left" fontSize={20} fontWeight={700}>
              Filtrar histórico:
            </Box>
            <AccordionIcon />
          </AccordionButton>
        </h2>
        <AccordionPanel pb={4} backgroundColor={'white'}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Box backgroundColor={'white'}>
              <Layout type="row" gutter={{ y: 1.5 }}>
                {formData.map(
                  ({ layout, input, select }, key) => (
                    <Layout {...layout} key={key}>
                      {select ? (
                        <SelectBuild
                          {...select}
                          id={select.id}
                          err={errors[select.id as FormHistoryElements]}
                          {...register(select.id as FormHistoryElements)}
                           value={watch(select.id as FormHistoryElements)}
                        />
                      ) : (
                        input && (
                          <InputBuild
                            {...input}
                            id={input.id}
                            err={errors[input.id as FormHistoryElements]}
                            {...register(input.id as FormHistoryElements)}
                            value={watch(input.id as FormHistoryElements)}
                          />
                        )
                      )}
                    </Layout>
                  )
                )}
              </Layout>
              <Box
                paddingY={8}
                display="flex"
                alignItems="center"
                justifyContent="center"
                gap={6}
              >
                <Button
                  colorScheme="primary"
                  variant="outline"
                  onClick={handleClear}
                >
                  Limpar Campos
                </Button>
                <Button
                  colorScheme="primary"
                  type="submit"
                  isLoading={isLoading}
                >
                  Filtrar
                </Button>
              </Box>
            </Box>
          </form>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
};